import { useEffect, useRef, useState } from "react";

import { MarketState, TICK_MS, advanceMarket, createInitialMarket, createRng } from "./terminalMock";

const SEED = 9137;

/**
 * Seeded mock market state with an optional 1400ms live tick.
 * Replace with the real feeds; the shape is what the terminal renders against.
 */
export function useTerminalMarket(liveUpdates = true): MarketState {
  const rndRef = useRef<(() => number) | null>(null);
  if (!rndRef.current) {
    rndRef.current = createRng(SEED);
  }
  const rnd = rndRef.current;

  const [market, setMarket] = useState<MarketState>(() => createInitialMarket(rnd, Date.now()));

  useEffect(() => {
    if (!liveUpdates) {
      return;
    }

    const timer = setInterval(() => {
      setMarket((prev) => advanceMarket(prev, rnd, Date.now()));
    }, TICK_MS);

    return () => clearInterval(timer);
  }, [liveUpdates, rnd]);

  return market;
}
